import { forwardRef, useEffect } from 'react';
// import cookie from '@/helpers/cookie';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import Emitter from '@/helpers/emitter.js';
import { useTranslation } from '@/helpers/translate';

const wrapperStartTour = (Component) => forwardRef(({ onValid, ...props }, ref) => {
  const { t } = useTranslation();
  const order = props?.item?.startTour?.order;

  function openModal() {
    if (ref?.current?.isSameDefault?.() === false) {
      Emitter.emit('emit_done_index', order);
    } else {
      ref?.current?.setIsOpenModal(true);
    }
  }
  useEffect(() => {
    if (props?.item?.open) {
      ref?.current?.setIsOpenModal(true);
    }
  }, []);
  useEffect(() => {
    if (order) {
      Emitter.on(`emit_start_order_index_${order}`, openModal);
    }
    return () => {
      if (order) Emitter.off(`emit_start_order_index_${order}`, openModal);
    };
  }, [ref, order]);

  function setNextTour(noRunValid) {
    if (noRunValid === 'iconclose') {
      Emitter.emit('emit_done_tour');
    } else {
      if (order) Emitter.emit('emit_done_index', order);
      if (!noRunValid) onValid();
    }
  }

  function renderButtonStartTour() {
    const { isTour } = useSearchZustandStore.getState();
    if (!isTour || !order) return null;
    return (
      <span className="mr-2">
        <button className="rounded-lg text-base text-black-light bg-purple-0 hover:text-purplehover:bg-purple/10 py-2 px-3" onClick={() => ref?.current?.setIsOpenModal('outside')}>{t('btn:pass')}</button>
      </span>
    );
  }

  return (
    <Component
      ref={ref}
      onValid={(action) => setNextTour(action)}
      renderButtonStartTour={() => renderButtonStartTour()}
      {...props}
    />
  );
});

export default wrapperStartTour;
